document.documentElement.classList.add('w-mod-js');
document.addEventListener('click', function (event) {
  function closeMenu() {
    var button = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-menu]');
    if (button) button.setAttribute('aria-expanded', 'false');
    if (menu) menu.classList.remove('w--open');
  }
  var toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    var menu = document.querySelector('[data-menu]');
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    if (menu) menu.classList.toggle('w--open', !open);
  }
  if (event.target.closest('[data-menu-close]')) closeMenu();
  if (event.target.closest('[data-menu] a')) closeMenu();
  var thumb = event.target.closest('[data-product-image]');
  if (thumb) {
    var product = thumb.closest('.main-product-editable');
    var main = product && product.querySelector('[data-main-product-image]');
    if (main) {
      main.src = thumb.dataset.productImage;
      main.srcset = '';
      main.alt = thumb.dataset.alt || '';
    }
    var thumbnails = thumb.closest('.product-media__thumbs');
    if (thumbnails) {
      thumbnails.querySelectorAll('[data-product-image]').forEach(function (item) {
        item.classList.toggle('is-active', item === thumb);
      });
    }
  }
});

function getSelectedProductOptions(form) {
  return Array.from(form.querySelectorAll('[data-product-option-group]')).map(function (group) {
    var control = group.querySelector('select[data-product-option]') || group.querySelector('input[data-product-option]:checked');
    var selectedLabel = group.querySelector('[data-selected-option]');
    if (selectedLabel && control) selectedLabel.textContent = control.value;
    return control ? control.value : null;
  });
}

function optionHasAvailableVariant(variants, selectedOptions, optionIndex, optionValue) {
  return variants.some(function (variant) {
    if (!variant.available) return false;
    return variant.options.every(function (value, index) {
      return index === optionIndex ? value === optionValue : value === selectedOptions[index];
    });
  });
}

function updateProductOptionAvailability(form, picker, variants, selectedOptions) {
  var behavior = picker.dataset.unavailableOptions || 'disable';
  form.querySelectorAll('[data-product-option-group]').forEach(function (group, groupIndex) {
    var select = group.querySelector('select[data-product-option]');
    if (select) {
      Array.from(select.options).forEach(function (option) {
        var available = optionHasAvailableVariant(variants, selectedOptions, groupIndex, option.value);
        option.disabled = behavior === 'disable' && !available;
        option.hidden = behavior === 'hide' && !available && !option.selected;
      });
      return;
    }
    group.querySelectorAll('input[data-product-option]').forEach(function (input) {
      var available = optionHasAvailableVariant(variants, selectedOptions, groupIndex, input.value);
      input.disabled = behavior === 'disable' && !available;
      var wrapper = input.closest('.variant-picker__button-option');
      if (wrapper) wrapper.hidden = behavior === 'hide' && !available && !input.checked;
    });
  });
}

function updateProductFromOptions(control) {
  var form = control.closest('form');
  if (!form) return;
  var picker = control.closest('[data-variant-picker]');
  var variantsElement = form.querySelector('[data-product-variants]');
  if (!picker || !variantsElement) return;
  var variants = JSON.parse(variantsElement.textContent);
  var selectedOptions = getSelectedProductOptions(form);
  var variant = variants.find(function (item) {
    return item.options.every(function (value, index) {
      return value === selectedOptions[index];
    });
  });
  var variantInput = form.querySelector('[data-product-variant-id]');
  var price = form.querySelector('[data-product-price]');
  var comparePrice = form.querySelector('[data-product-compare-price]');
  var button = form.querySelector('[data-add-to-cart]');
  if (variantInput) variantInput.value = variant ? variant.id : '';
  if (price && variant) price.textContent = variant.price;
  if (comparePrice) {
    var showComparePrice = comparePrice.dataset.showComparePrice === 'true';
    comparePrice.textContent = variant && variant.compareAtPrice ? variant.compareAtPrice : '';
    comparePrice.hidden = !showComparePrice || !variant || !variant.compareAtPrice;
  }
  if (button) {
    button.disabled = !variant || !variant.available;
    button.textContent = !variant ? button.dataset.unavailableText : variant.available ? button.dataset.availableText : button.dataset.soldOutText;
  }
  var product = form.closest('.main-product-editable');
  var mainImage = product && product.querySelector('[data-main-product-image]');
  if (mainImage && variant && variant.featuredImage) {
    mainImage.src = variant.featuredImage;
    mainImage.srcset = '';
  }
  if (variant && picker.dataset.updateUrl === 'true') {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }
  updateProductOptionAvailability(form, picker, variants, selectedOptions);
}

document.addEventListener('change', function (event) {
  if (event.target.matches('[data-product-option]')) {
    updateProductFromOptions(event.target);
    return;
  }
  if (!event.target.matches('[data-product-variant]')) return;
  var option = event.target.selectedOptions[0];
  var form = event.target.closest('form');
  var price = form && form.querySelector('[data-product-price]');
  var button = form && form.querySelector('[data-add-to-cart]');
  if (price) price.textContent = option.dataset.price;
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? button.dataset.availableText : button.dataset.soldOutText;
  }
});
